export default __webpack_public_path__ + "static/media/livingroom2.0aa507dc.jpg";